var _rect, _rect2, _g, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPluginFileEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_395_27292",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 18,
    height: 18
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_395_27292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.625 21.75C15.3771 21.75 15.1693 21.6661 15.0016 21.4984C14.8339 21.3307 14.75 21.1229 14.75 20.875C14.75 20.6271 14.8339 20.4193 15.0016 20.2516C15.1693 20.0839 15.3771 20 15.625 20C16.3104 20 16.9193 19.8651 17.4516 19.5953C17.9839 19.3255 18.25 19.0229 18.25 18.6875C18.25 18.4833 18.1552 18.2938 17.9656 18.1188C17.776 17.9438 17.5135 17.7833 17.1781 17.6375L18.4688 16.3469C18.9354 16.624 19.3073 16.9521 19.5844 17.3313C19.8615 17.7104 20 18.1625 20 18.6875C20 19.65 19.5406 20.401 18.6219 20.9406C17.7031 21.4802 16.7042 21.75 15.625 21.75ZM7.37813 15.0563C6.95521 14.8083 6.61979 14.5203 6.37188 14.1922C6.12396 13.8641 6 13.4667 6 13C6 12.3875 6.22604 11.8734 6.67813 11.4578C7.13021 11.0422 7.93958 10.5792 9.10625 10.0687C10.025 9.64583 10.612 9.35052 10.8672 9.18281C11.1224 9.0151 11.25 8.82917 11.25 8.625C11.25 8.39167 11.1078 8.1875 10.8234 8.0125C10.5391 7.8375 10.0979 7.75 9.5 7.75C9.13542 7.75 8.82917 7.79375 8.58125 7.88125C8.33333 7.96875 8.10729 8.11458 7.90312 8.31875C7.74271 8.47917 7.54583 8.57396 7.3125 8.60313C7.07917 8.63229 6.86771 8.56667 6.67813 8.40625C6.48854 8.26042 6.37917 8.07083 6.35 7.8375C6.32083 7.60417 6.38646 7.39271 6.54688 7.20312C6.82396 6.86771 7.22135 6.58333 7.73906 6.35C8.25677 6.11667 8.84375 6 9.5 6C10.55 6 11.3958 6.23698 12.0375 6.71094C12.6792 7.1849 13 7.82292 13 8.625C13 9.19375 12.7885 9.70417 12.3656 10.1562C11.9427 10.6083 11.0896 11.1115 9.80625 11.6656C8.96042 12.0302 8.40625 12.3 8.14375 12.475C7.88125 12.65 7.75 12.825 7.75 13C7.75 13.1312 7.83385 13.2589 8.00156 13.3828C8.16927 13.5068 8.39896 13.6271 8.69062 13.7438L7.37813 15.0563ZM19.8688 12.475L16.15 8.75625L17.0688 7.8375C17.4188 7.4875 17.838 7.3125 18.3266 7.3125C18.8151 7.3125 19.2271 7.4875 19.5625 7.8375L20.7875 9.0625C21.1375 9.39792 21.3125 9.8099 21.3125 10.2984C21.3125 10.787 21.1375 11.2062 20.7875 11.5563L19.8688 12.475ZM8.625 20H9.85L16.15 13.7L14.925 12.475L8.625 18.775V20ZM6.875 21.75V18.0312L14.925 9.98125L18.6438 13.7L10.5938 21.75H6.875Z",
    fill: "black"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#FFDF0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluginFileEdit);
export default __webpack_public_path__ + "static/media/plugin_file_edit.f0ef632ea315b13725b49d2d69c7a484.svg";
export { ForwardRef as ReactComponent };